export const BASE_API_PATH = import.meta.env.VITE_APP_BASE_API

export const TOKEN_KEY = 'X-Access-Token'

export const Version_Code = 'version_code'
